import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { PlusIcon } from 'components/icons';
import { ButtonsProps } from '../types';

export const AddButton: FC<ButtonsProps> = (props) => {
  const { t } = useTranslation('translation');

  return (
    <Button type="text" icon={<PlusIcon />} {...props}>
      {props.title || t('Add')}
    </Button>
  );
};
